import * as React from "react";
import type { SVGProps } from "react";
const SvgSunset = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 18a1 1 0 1 0 2 0zm-4-5v-1zm-6 5a1 1 0 1 0 2 0zm6-9-.707.707a1 1 0 0 0 1.414 0zm1-7a1 1 0 1 0-2 0zM4.927 9.513a1 1 0 0 0-1.414 1.414zm.006 2.834a1 1 0 0 0 1.414-1.414zM1 17a1 1 0 1 0 0 2zm2 2a1 1 0 1 0 0-2zm18-2a1 1 0 1 0 0 2zm2 2a1 1 0 1 0 0-2zm-5.347-8.067a1 1 0 0 0 1.414 1.414zm2.834-.006a1 1 0 0 0-1.414-1.414zM23 23a1 1 0 1 0 0-2zM1 21a1 1 0 1 0 0 2zM16.707 5.707a1 1 0 0 0-1.414-1.414zm-8-1.414a1 1 0 0 0-1.414 1.414zM18 18a6 6 0 0 0-1.757-4.243l-1.415 1.415A4 4 0 0 1 16 18zm-1.757-4.243A6 6 0 0 0 12 12v2a4 4 0 0 1 2.828 1.172zM12 12a6 6 0 0 0-4.243 1.757l1.415 1.415A4 4 0 0 1 12 14zm-4.243 1.757A6 6 0 0 0 6 18h2a4 4 0 0 1 1.172-2.828zM13 9V2h-2v7zm-9.487 1.927 1.42 1.42 1.414-1.414-1.42-1.42zM1 19h2v-2H1zm20 0h2v-2h-2zm-1.933-6.653 1.42-1.42-1.414-1.414-1.42 1.42zM23 21H1v2h22zM15.293 4.293l-4 4 1.414 1.414 4-4zm-2.586 4-4-4-1.414 1.414 4 4z"
    />
  </svg>
);
export default SvgSunset;
